import { Cookies } from 'react-cookie';
import _ from 'lodash';

const cookies = new Cookies();

export const getCookie = (cookieName) => {
  const val = cookies.get(cookieName, { path: '/' });
  if (val === 'undefined' || !val) {
    return null;
  }
  return val;
};

export const saveCookies = (params) => {
  Object.keys(params).forEach((key) => {
    cookies.set(key, _.get(params, key, ''), { path: '/' });
  });
};

export const clearCookies = () => {
  cookies.remove('IdToken', { path: '/' });
  cookies.remove('RefreshToken', { path: '/' });
  cookies.remove('AccessToken', { path: '/' });
};

export const saveCustomInboxCookie = (params) => {
  cookies.set('customInboxParams', params, { path: '/' });
};

export const saveAnalyticsCookie = (params) => {
  cookies.set('analyticsFilters', params, { path: '/' });
};

export const getCustomInboxCookie = () => {
  const customInboxParams = cookies.get('customInboxParams');
  if (!customInboxParams) {
    return null;
  }
  return customInboxParams;
};

export const saveBranding = (params) => {
  cookies.set('savedBranding', params, { path: '/' });
};

export const saveBrowserCheckCookie = (wasChecked) => {
  cookies.set('wasBrowserChecked', wasChecked, { path: '/' });
};

export const getBrowserCheckCookie = () => {
  const wasBrowserChecked = cookies.get('wasBrowserChecked');
  if (!wasBrowserChecked) {
    return null;
  }
  return wasBrowserChecked;
};

export const saveQueueCookie = (activeQueueId) => {
  cookies.set('activeQueueId', activeQueueId, { path: '/' });
};

export const getUserId = () => {
  const user = cookies.get('user');
  return user ? user._id : null;
};
